module.exports = __webpack_public_path__ + "static/media/Fire.d5dc9732.PNG";